




































































































































































































































































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DemoServer from "../../shared/DemoServer";
import DateFormatter from "../../shared/DateFormatter";
import OverlayWindow from "../general/OverlayWindow.vue";
import Loading from "../general/Loading.vue";
import EventsCalendarOverlay from "./EventsCalendarOverlay.vue";

import InvoiceInfoDetails from "../general/InvoiceInfoDetails.vue";
import FormDateTimeBeginEnd from "../general/FormDateTimeBeginEnd.vue";
import FormPriceSelect from "../general/FormPriceSelect.vue";
import FormContact from "../general/FormContact.vue";
import FormSepaMandate from "../general/FormSepaMandate.vue";
import LocationInput from "../general/LocationInput.vue";
import MaterialItemInput from "../general/MaterialItemInput.vue";
import StaffInput from "../general/StaffInput.vue";
import CustomInputView from "../controls/CustomInputView.vue";

import ClientsClientSelect from "../clients/ClientsClientSelect.vue";

import SettingsJson from "../../shared/SettingsJson";
import EventJson from "../../shared/EventJson";
import EventBookingJson, { defaultEventBookingJson, defaultEventOfferBookingJson } from "../../shared/EventBookingJson";
import { EventWithBookingsJson } from "../../shared/EventJson";
import { EventBookingStatus, EventBookingStatusNames } from "../../shared/EventBookingStatus";
import { defaultEventDateJson } from "../../shared/EventDateJson";
import ContactJson, { defaultContactJson, getContactAge } from "../../shared/ContactJson";
import ClientJson from "../../shared/ClientJson";
import SepaMandateJson, { defaultSepaMandateJson } from "../../shared/SepaMandateJson";
import { CustomInputCategory } from "../../shared/CustomInputCategory";

import { UserPermissionRank } from "../../shared/UserPermissionRank";
import { Gender, GenderNames } from "../../shared/Gender";

import {
  validateEventBookingJsonManagement,
  validateEventBookingJsonManagementAdd,
  validateEventOfferBookingJsonManagement,
  validateEventOfferBookingJsonManagementAdd,
} from "../../shared/EventBookingJson";
import { ValidationResult, Validation } from "../../shared/Validation";

export default Vue.extend({
  name: "EventBookingDetails",
  components: {
    OverlayWindow,
    Loading,
    EventsCalendarOverlay,
    FormDateTimeBeginEnd,
    FormPriceSelect,
    FormContact,
    FormSepaMandate,
    LocationInput,
    MaterialItemInput,
    StaffInput,
    CustomInputView,
    InvoiceInfoDetails,
    ClientsClientSelect,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    selectedEventId: Number,
    selectedBookingId: Number,
    mode: String,
  },
  data() {
    return {
      DemoServer: DemoServer,
      DateFormatter: DateFormatter,
      CustomInputCategory: CustomInputCategory,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      Gender: Gender,
      GenderNames: GenderNames,
      EventBookingStatus: EventBookingStatus,
      EventBookingStatusNames: EventBookingStatusNames,
      detailsMode: "",
      eventTitle: "" as string,
      eventDetails: null as EventWithBookingsJson | null,
      eventBookingDetails: null as EventBookingJson | null,
      contactToAdd: null as ContactJson | null,
      participantsAreAdults: false as boolean,
      useSepaMandate: false as boolean,
      hasChanges: false,
      hintChanged: {
        statusChanged: false as boolean,
        selectedPrice: false as boolean,
      },
      toValidate: {} as any,
      validation: null as ValidationResult<EventBookingJson> | null,
      frontendValidations: {} as { [index: string]: boolean },
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingNextup: false as boolean,
      showCalendarOverlay: false as boolean,
    };
  },
  created() {
    this.initEventBookingDetails();
  },
  mounted() {},
  methods: {
    /*** START: details view ***/
    toggleCalendarOverlay() {
      this.showCalendarOverlay = !this.showCalendarOverlay;
    },

    openCalendarOverlay() {
      this.toggleCalendarOverlay();
    },
    /*** END: details view ***/

    initEventBookingDetails() {
      this.loadEventDetails();
    },

    //removed date support without browser datepicker

    async loadEventDetails() {
      if (this.selectedEventId != null) {
        try {
          this.eventDetails = await this.restClient.getEventWithBookings(this.selectedEventId);

          this.selectDetailsMode(this.mode);

          this.loadEventBookingDetails();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadEventBookingDetails() {
      if (this.selectedEventId != null) {
        if (this.selectedBookingId != null) {
          try {
            let eventBooking = await this.restClient.getEventBooking(this.selectedEventId, this.selectedBookingId);

            this.eventBookingDetails = eventBooking.booking;

            if (this.eventBookingDetails.sepaMandate != null) {
              this.useSepaMandate = true;
            }
          } catch (e) {
            alert(e.message);
          }
        } else {
          this.loadDefaultBookingDetails();
        }

        this.$nextTick(() => {
          this.hasChanges = false;
        });
      }
    },

    loadDefaultBookingDetails() {
      if (this.eventDetails && this.eventDetails.dates) {
        this.eventBookingDetails = { ...defaultEventBookingJson(), participants: [] };
      } else {
        this.eventBookingDetails = { ...defaultEventOfferBookingJson() };
      }

      if (this.eventDetails && this.eventDetails.customInputs.length > 0) {
        this.eventBookingDetails.customInputs = [...this.eventDetails.customInputs];
      }

      if (this.eventDetails && this.eventDetails.prices.length > 0)
        this.eventBookingDetails.selectedPrice = { ...this.eventDetails.prices[0] };
    },

    getDefaultSepaMandate(): SepaMandateJson {
      if (
        this.eventBookingDetails != null &&
        this.eventBookingDetails.client &&
        this.eventBookingDetails.client.sepaMandate
      ) {
        return { ...this.eventBookingDetails.client.sepaMandate };
      } else if (this.eventBookingDetails != null && this.eventBookingDetails.contact != null) {
        return {
          ...defaultSepaMandateJson(),
          accountHolderFirstName: this.eventBookingDetails.contact.firstName,
          accountHolderLastName: this.eventBookingDetails.contact.lastName,
          addressStreet: this.eventBookingDetails.contact.addressStreet,
          addressZip: this.eventBookingDetails.contact.addressZip,
          addressCity: this.eventBookingDetails.contact.addressCity,
          addressCountry: this.eventBookingDetails.contact.addressCountry,
        };
      } else {
        return { ...defaultSepaMandateJson() };
      }
    },

    //START set cached data

    //END set cached data

    async reloadDetailsView() {
      if (this.selectedEventId != null && this.selectedBookingId != null) {
        this.eventBookingDetails = null;
        try {
          let eventBooking = await this.restClient.getEventBooking(this.selectedEventId, this.selectedBookingId);

          this.eventBookingDetails = eventBooking.booking;

          if (this.eventBookingDetails.sepaMandate != null) {
            this.useSepaMandate = true;
          }

          this.$nextTick(() => {
            this.hasChanges = false;
          });
        } catch (e) {
          alert(e.message);
        }
      } else {
        this.closeDetails();
      }
    },

    selectDetailsMode(mode: string) {
      this.resetHintChanged();

      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Buchung hinzufügen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Buchung bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Buchung für " + this.eventDetails?.title;
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    resetHintChanged() {
      let k = this.hintChanged;
      let i: keyof typeof k;

      for (i in this.hintChanged) {
        this.hintChanged[i] = false;
      }
    },

    stopEditMode() {
      if (!this.hasChanges) {
        this.selectDetailsMode("show");
        this.reloadDetailsView();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.selectDetailsMode("show");
          this.reloadDetailsView();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.eventDetails != null && this.eventBookingDetails != null) {
        this.validation = this.eventDetails.dates
          ? validateEventBookingJsonManagement(this.eventBookingDetails)
          : validateEventOfferBookingJsonManagement(this.eventBookingDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    /* START frontend validation */

    frontendValidation() {
      this.validateAge();
    },

    validateAge() {
      if (
        this.eventDetails != null &&
        this.eventDetails.dates != null &&
        this.eventBookingDetails != null &&
        this.eventBookingDetails.participants != null
      ) {
        this.frontendValidations.minimumAge = false;
        this.frontendValidations.maximumAge = false;

        let beginDate = this.eventDetails.dates[0].beginDateTime;

        for (let p of this.eventBookingDetails.participants) {
          if (p.birthDate) {
            let testDate = new Date(beginDate);
            let birthDate = new Date(p.birthDate);

            let age = testDate.getFullYear() - birthDate.getFullYear();
            let month = testDate.getMonth() - birthDate.getMonth();
            if (month < 0 || (month === 0 && testDate.getDate() < birthDate.getDate())) {
              age--;
            }

            if (this.eventDetails.restrictMinimumAge != null && age < this.eventDetails.restrictMinimumAge) {
              this.frontendValidations.minimumAge = true;
            }

            if (this.eventDetails.restrictMaximumAge != null && age > this.eventDetails.restrictMaximumAge) {
              this.frontendValidations.maximumAge = true;
            }
          }
        }
      }
    },

    checkFrontendValidations() {
      let check = true;

      let k = this.frontendValidations;
      let i: keyof typeof k;
      for (i in this.frontendValidations) {
        if (this.frontendValidations[i] == true) {
          check = false;
        }
      }

      return check;
    },

    /* END frontend validation */

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    // client / participants / contact

    selectClient(client: ClientJson) {
      if (this.eventBookingDetails) {
        this.eventBookingDetails.client = client;

        if (client == null) {
          this.eventBookingDetails.participants = [];
          this.eventBookingDetails.contact = { ...defaultContactJson() };
          this.eventBookingDetails.sepaMandate = null;
        }
      }
    },

    addParticipant() {
      if (this.eventBookingDetails != null && this.eventBookingDetails.participants != null) {
        if (this.contactToAdd != null) {
          this.eventBookingDetails.participants.push({ ...this.contactToAdd, ID: null });
          this.contactToAdd = null;
        } else {
          this.eventBookingDetails.participants.push({ ...defaultContactJson() });
        }

        this.changeParticipant();
        this.updateMainContactFromParticipant();
      }
    },

    deleteParticipant(index: number) {
      if (this.eventBookingDetails != null && this.eventBookingDetails.participants != null) {
        this.eventBookingDetails.participants.splice(index, 1);
        this.changeParticipant();

        delete this.toValidate["participants-" + index];
      }
    },

    blurParticipant(index: number = -1) {
      this.updateMainContactFromParticipant(index);
    },

    changeParticipant(index: number = -1) {
      this.checkParticipantsAreAdults();
    },

    updateMainContactFromParticipant(index: number = -1) {
      if (this.eventBookingDetails && this.eventBookingDetails.participants && this.eventBookingDetails.contact) {
        if (
          index <= 0 &&
          this.eventBookingDetails.participants[0].birthDate &&
          getContactAge(this.eventBookingDetails.participants[0].birthDate) >= 18
        ) {
          /* let contact: ContactJson = this.eventBookingDetails.contact;
          let key: keyof typeof contact;

          for (key in contact) {
            if (
              this.eventBookingDetails.contact[key as keyof ContactJson] == "" ||
              this.eventBookingDetails.contact[key as keyof ContactJson] == null
            ) {
              this.eventBookingDetails.contact[key as keyof ContactJson] =
                this.eventBookingDetails.participants[0][key as keyof ContactJson];
            }
          } */

          /* for ([key, value] of Object.entries(this.eventBookingDetails.contact)) {
            if (value == "" || value == null) {
              this.eventBookingDetails.contact[key] = this.eventBookingDetails.participants[0][key];
            }
          } */

          if (this.eventBookingDetails.contact.organisation == "")
            this.eventBookingDetails.contact.organisation = this.eventBookingDetails.participants[0].organisation;
          if (this.eventBookingDetails.contact.salutation == "")
            this.eventBookingDetails.contact.salutation = this.eventBookingDetails.participants[0].salutation;
          if (this.eventBookingDetails.contact.gender == null)
            this.eventBookingDetails.contact.gender = this.eventBookingDetails.participants[0].gender;
          if (this.eventBookingDetails.contact.firstName == "")
            this.eventBookingDetails.contact.firstName = this.eventBookingDetails.participants[0].firstName;
          if (this.eventBookingDetails.contact.lastName == "")
            this.eventBookingDetails.contact.lastName = this.eventBookingDetails.participants[0].lastName;
          if (this.eventBookingDetails.contact.birthDate == null)
            this.eventBookingDetails.contact.birthDate = this.eventBookingDetails.participants[0].birthDate;
          if (this.eventBookingDetails.contact.email == "")
            this.eventBookingDetails.contact.email = this.eventBookingDetails.participants[0].email;
          if (this.eventBookingDetails.contact.phone == "")
            this.eventBookingDetails.contact.phone = this.eventBookingDetails.participants[0].phone;
          if (this.eventBookingDetails.contact.addressStreet == "")
            this.eventBookingDetails.contact.addressStreet = this.eventBookingDetails.participants[0].addressStreet;
          if (this.eventBookingDetails.contact.addressZip == "")
            this.eventBookingDetails.contact.addressZip = this.eventBookingDetails.participants[0].addressZip;
          if (this.eventBookingDetails.contact.addressCity == "")
            this.eventBookingDetails.contact.addressCity = this.eventBookingDetails.participants[0].addressCity;
          if (this.eventBookingDetails.contact.addressCountry == "")
            this.eventBookingDetails.contact.addressCountry = this.eventBookingDetails.participants[0].addressCountry;
        }
      }
    },

    checkParticipantsAreAdults() {
      if (this.eventBookingDetails && this.eventBookingDetails.participants) {
        this.participantsAreAdults = !this.eventBookingDetails.participants.some((i: ContactJson) =>
          i.birthDate ? getContactAge(i.birthDate) < 18 : true
        );
      }
    },

    addMainContact() {
      if (this.eventBookingDetails != null) {
        if (this.contactToAdd != null) {
          this.eventBookingDetails.contact = { ...this.contactToAdd, ID: null };
          this.contactToAdd = null;
        } else {
          this.eventBookingDetails.contact = { ...defaultContactJson() };
        }
      }
    },

    toggleUseSepaMandate() {
      if (this.eventBookingDetails != null) {
        if (this.useSepaMandate) {
          this.eventBookingDetails.sepaMandate = null;
          this.useSepaMandate = false;
        } else {
          this.eventBookingDetails.sepaMandate = this.getDefaultSepaMandate();
          this.useSepaMandate = true;
        }
      }
    },

    setBookedDates() {
      if (this.eventBookingDetails != null && this.eventBookingDetails.desiredDates) {
        if (this.eventBookingDetails.bookedDates == null) {
          this.eventBookingDetails.bookedDates = [];
        }

        for (let date of this.eventBookingDetails.desiredDates) {
          this.eventBookingDetails.bookedDates.push({
            ...defaultEventDateJson(),
            beginDateTime: date.beginDateTime,
            endDateTime: date.endDateTime,
            remarks: date.remarks,
          });
        }
      }
    },

    async saveEventBookingDetails() {
      if (this.eventDetails && this.eventBookingDetails != null && this.selectedEventId) {
        if (this.hasChanges) {
          this.loadingGeneral = true;

          this.frontendValidation();
          //todo ###START
          //todo: Validation muss durchgeführt werden (siehe hier) ->AUCH bei SettingsDetails
          this.validation = this.eventDetails.dates
            ? validateEventBookingJsonManagement(this.eventBookingDetails)
            : validateEventOfferBookingJsonManagement(this.eventBookingDetails);
          //todo ###END

          if (
            this.eventBookingDetails.state == EventBookingStatus.incomplete ||
            (this.checkFrontendValidations() && this.validation != null && this.validation.isValid == true)
          ) {
            if (this.restClient != null) {
              try {
                let updatedeventDetails = await this.restClient.updateEventBooking(
                  this.selectedEventId,
                  this.eventBookingDetails
                );

                alert("Die Änderungen wurden erfolgreich gespeichert.");

                this.$nextTick(() => {
                  this.hasChanges = false;
                  this.loadingGeneral = false;
                  this.stopEditMode();
                });
              } catch (e) {
                this.loadingGeneral = false;
                alert(e.message);
              }
            }
          } else {
            this.loadingGeneral = false;
            let c = confirm(
              "Die Buchung ist nicht vollständig ausgefüllt. Wollen Sie die Buchung als unvollständig abspeichern?"
            );
            if (c) {
              this.eventBookingDetails.state = EventBookingStatus.incomplete;
              this.addNewEventBooking();
            } else {
              //do nothing
            }
          }
        } else {
          alert("Es wurden keine Änderungen vorgenommen.");
        }
      }
    },

    async addNewEventBooking() {
      if (this.eventDetails && this.eventBookingDetails != null && this.selectedEventId != null) {
        this.loadingGeneral = true;

        //auto. set bookedDates
        this.setBookedDates();

        this.frontendValidation();
        this.validation = this.eventDetails.dates
          ? validateEventBookingJsonManagementAdd(this.eventBookingDetails)
          : validateEventOfferBookingJsonManagementAdd(this.eventBookingDetails);

        this.submitValidation = true;

        if (
          this.eventBookingDetails.state == EventBookingStatus.incomplete ||
          (this.checkFrontendValidations() && this.validation != null && this.validation.isValid == true)
        ) {
          try {
            this.eventBookingDetails = await this.restClient.addEventBooking(
              this.selectedEventId,
              this.eventBookingDetails
            );
            alert("Die Buchung wurde erfolgreich hinzugefügt.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          let c = confirm(
            "Die Buchung ist nicht vollständig ausgefüllt. Wollen Sie die Buchung als unvollständig abspeichern?"
          );
          if (c) {
            this.eventBookingDetails.state = EventBookingStatus.incomplete;
            this.addNewEventBooking();
          } else {
            //do nothing
          }
        }
      }
    },

    async deleteEventBooking() {
      if (this.selectedEventId != null && this.selectedBookingId != null) {
        let c = confirm("Wollen Sie diese Buchung wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteEventBooking(this.selectedEventId, this.selectedBookingId);
              this.closeDetails();
              alert("Die Buchung wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    async sendBookingConfirmation() {
      this.loadingNextup = true;

      if (this.hasChanges) {
        await this.saveEventBookingDetails();
      }

      if (this.selectedEventId != null && this.selectedBookingId != null && this.restClient != null) {
        try {
          await this.restClient.confirmEventBooking(this.selectedEventId, this.selectedBookingId);
          alert("Es wurde eine Bestätigung an den Kunden gesendet.");
          this.hasChanges = false;
          this.stopEditMode();
          this.loadingNextup = false;
        } catch (e) {
          alert(e.message);
          this.loadingNextup = false;
        }
      }
    },

    async cancelEventBooking() {
      if (!this.hasChanges) {
        if (this.eventBookingDetails != null && this.selectedEventId != null) {
          let c = confirm(
            "Wollen Sie die Absage per E-Mail bestätigen? Die Buchung wird unter Berücksichtigung der Stornierungsgebühr (€ " +
              this.getFormatPrice(this.eventBookingDetails.selectedPrice.cancellationFee) +
              ") abgesagt."
          );
          if (c == true) {
            this.loadingGeneral = true;

            if (this.restClient != null) {
              try {
                await this.restClient.cancelEventBooking(this.selectedEventId, this.selectedBookingId);
                this.closeDetails();
                alert("Die Buchung wurde erfolgreich abgesagt.");

                this.loadingGeneral = false;
              } catch (e) {
                alert(e.message);

                this.loadingGeneral = false;
              }
            }
          } else {
            //do nothing
          }
        }
      } else {
        alert("Bitte speichern Sie zuvor die letzten Änderungen.");
      }
    },

    // print
    printBookingDetails() {
      var toPrint = document.getElementById("toPrint");

      if (toPrint != null) {
        var eles = this.$el.querySelectorAll(".print-view");

        for (let i = 0; i < eles.length; i++) {
          toPrint.appendChild(eles[i].cloneNode(true));
        }
      }

      this.$nextTick(() => {
        window.print();
      });

      this.$nextTick(() => {
        while (toPrint?.lastElementChild) {
          toPrint.removeChild(toPrint.lastElementChild);
        }
      });
    },

    getFormatPrice(price: number) {
      return price
        .toString()
        .padStart(3, "0")
        .replace(/(\d{2,2})$/g, ",$1")
        .replace("NaN", "");
    },
  },

  watch: {
    eventBookingDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },

    eventRegistrationsLeftText(): string {
      if (this.eventDetails != null) {
        const maxRegistrationCount = this.eventDetails.registrationMaximumCount;
        let registrationCount = 0;

        for (let i = 0; i < this.eventDetails.bookings.length; i++) {
          if (
            this.eventDetails.bookings[i].state != "requested" &&
            this.eventDetails.bookings[i].state != "canceled" &&
            this.eventDetails.bookings[i].state != "cancellationFeeExported" &&
            this.eventDetails.bookings[i].state != "waitingList"
          ) {
            registrationCount++;
          }
        }

        if (maxRegistrationCount === undefined) {
          return "Freie Plätze: [Fehler]";
        }

        let registrationsLeft = maxRegistrationCount - registrationCount;

        if (registrationsLeft < 0) {
          return "Bereits überbucht";
        } else if (registrationsLeft == 1) {
          return "Noch 1 freier Platz";
        } else {
          return "Noch " + registrationsLeft + " freie Plätze";
        }
      }

      return "Lade freie Plätze...";
    },

    allClientContacts(): ContactJson[] | null {
      if (this.eventBookingDetails && this.eventBookingDetails.client) {
        var contacts = [];

        if (this.eventBookingDetails.client.contact) {
          contacts.push(this.eventBookingDetails.client.contact);
        }

        if (this.eventBookingDetails.client.relatives) {
          contacts = contacts.concat(this.eventBookingDetails.client.relatives);
        }

        if (contacts.length > 0) {
          return contacts;
        }
      }

      return null;
    },

    isDepositPaymentRequired(): boolean {
      if (this.eventBookingDetails != null) {
        if (this.eventBookingDetails.state == EventBookingStatus.bookedDepositPaymentExported) {
          if (this.eventBookingDetails.selectedPrice.priceDeposit === 0) {
            return false;
          }
        }
      }

      return true;
    },
  },
});
